import { render } from "./BalCard.vue?vue&type=template&id=6d4a4446&scoped=true&ts=true"
import script from "./BalCard.vue?vue&type=script&lang=ts"
export * from "./BalCard.vue?vue&type=script&lang=ts"

import "./BalCard.vue?vue&type=style&index=0&id=6d4a4446&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4a4446"]])

export default __exports__